// extracted by mini-css-extract-plugin
export default {"container":"aS-z","dimension":"bS-z","dimensionLabels":"cS-z"};